import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

export function StatsCards({ cards, testIdPrefix = 'stat-card' }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 mb-6 sm:mb-8" data-testid="stats-total-leads">
      {cards.map((card) => {
        const numeric = typeof card.value === 'number' ? card.value : Number(card.value);
        const animate = Number.isFinite(numeric);
        const inner = (
          <>
            <div className="flex items-center justify-between mb-2 sm:mb-3 gap-2">
              <span className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-slate-500 font-medium leading-tight">{card.label}</span>
              <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-sm flex items-center justify-center shrink-0 ${card.color}`}><card.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" /></div>
            </div>
            <p className="font-heading text-xl sm:text-3xl font-bold text-slate-900">
              {animate
                ? <CountUp end={numeric} duration={0.8} separator="," preserveValue />
                : card.value}
            </p>
          </>
        );
        const cardBg = card.cardBg || 'bg-white border-slate-200';
        const cls = `border rounded-sm p-3 sm:p-4 ${cardBg} transition-all duration-200 ${
          card.href
            ? 'hover:brightness-95 sm:hover:-translate-y-0.5 sm:hover:shadow-md cursor-pointer block'
            : 'hover:brightness-95 sm:hover:-translate-y-0.5 sm:hover:shadow-md'
        }`;
        const tid = `${testIdPrefix}-${card.label.replace(/\s+/g, '-').toLowerCase()}`;
        return card.href ? (
          <Link key={card.label} to={card.href} className={cls} data-testid={tid} aria-label={`View ${card.label}`}>
            {inner}
          </Link>
        ) : (
          <div key={card.label} className={cls} data-testid={tid}>
            {inner}
          </div>
        );
      })}
    </div>
  );
}
